import { mixed } from '@if/core/yup'
import { SignedCalendarSimulation } from '@src/types/loan/loan-simulation'

/** The form field every calendar dialog with a preview carries. */
export const CALENDAR_PREVIEW_FIELD = 'previewedSimulation'

export interface CalendarPreviewFormValues {
  previewedSimulation: SignedCalendarSimulation | null
}

/**
 * The recomputed calendar the dialog is showing — and the exact value Confirm applies, so
 * what the agent watched settle is what reaches the page rather than a fresh call fired on
 * submit.
 *
 * Deliberately **not** `required()`: the form's `isValid` then reports only whether the
 * agent's own fields are usable, which is what drives the recompute. Confirm adds "and a
 * preview has settled" on top through `confirmDisabled` — gating on validity alone would be
 * circular, since a settled preview is what a valid form produces.
 */
export const previewedSimulation = () => mixed<SignedCalendarSimulation>().nullable().defined().default(null)
